import "./Footer.css";
import React from "react";

const Footer = () => (
  <footer className="footer">
    <a
      href="https://github.com/vpbhartiya5"
      className="link footer__link"
      target="_blank"
      rel="noreferrer"
    >
      Created By Varun Bhartiya
    </a>
  </footer>
);

export default Footer;
